<template>
    <PatchNoteApproval></PatchNoteApproval>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const PatchNoteApproval = defineAsyncComponent(() =>
    import("../../components/PatchNotes/PatchNoteApproval.vue")
);

export default {
    name: "PatchNotes_Approval", //The name you are in should not equal the name of the component you are importing.
    components: { PatchNoteApproval, AuthLayout },
};
</script>
